import * as React from "react"
import { Search } from "lucide-react"

import { cn } from "@/lib/utils"

interface SearchInputProps extends Omit<React.ComponentProps<"input">, "type"> {
  containerClassName?: string
  iconClassName?: string
}

const SearchInput = React.forwardRef<HTMLInputElement, SearchInputProps>(
  ({ className, containerClassName, iconClassName, ...props }, ref) => (
    <div className={cn("relative", containerClassName)}>
      <Search
        aria-hidden="true"
        className={cn(
          "pointer-events-none absolute left-3 top-1/2 size-3.5 -translate-y-1/2 text-muted-foreground",
          iconClassName
        )}
      />
      <input
        ref={ref}
        type="text"
        className={cn(
          "h-9 w-full border border-border bg-background py-2 pl-8 pr-3 text-xs font-medium text-foreground transition-colors placeholder:text-muted-foreground/50 focus:border-primary focus:outline-none",
          className
        )}
        {...props}
      />
    </div>
  )
)
SearchInput.displayName = "SearchInput"

export { SearchInput }
